module.exports = __webpack_public_path__ + "static/1167431824.792fa3f4.jpg";